<!--
 * @Author: Src
 * @Date: 2024-12-18 09:26:58
 * @LastEditTime: 2024-12-18 09:59:43
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/shop/comments/PickerField.vue
 * @Description: 头部注释配置模板
-->
<template>
    <div>
        <el-date-picker v-model="val" type="date" placeholder="选择日期" :editable="false" value-format="yyyy-MM-dd">
        </el-date-picker>
    </div>
</template>
<script lang="ts">
import { Vue, Component, Model, Watch } from 'vue-property-decorator';

@Component({})
export default class InputField extends Vue {
    val: any = '';

    @Watch('val')
    watchInternalVal(): void {
        if (this.val !== null) {
            this.$emit('change', this.val);
        } else {
            this.$emit('change', '');
        }
    }


    @Model('change', {
        type: String,
    })
    value!: string;

    @Watch('value')
    watchValue() {
        if (!this.value || this.value === '') {
            this.val = '';
            return;
        }
        this.val = this.value;
    }

    mounted() {
        this.watchValue();

    }
}
</script>
